/** @jsxImportSource @emotion/react */
import Profile from '@components/Profile'

export default function HomePage() {
  return <Profile />
}
